import { SequenceMenuItemType } from '@sequencehq/core-components'
import { Currency } from '@sequencehq/api'
import { PriceEditorPercentageTier } from '../../../domain'
import { copyPricingTableToClipboard } from '../../../utils'

export const kebabMenuItems = (args: {
  includePercentageLimits: boolean
  onChange: (newValue: boolean) => void
  percentageTiers?: PriceEditorPercentageTier[]
  currency?: Currency
}): SequenceMenuItemType[] => {
  const text = args.includePercentageLimits
    ? 'Remove fee thresholds'
    : 'Add fee thresholds'

  const menuItems: SequenceMenuItemType[] = [
    {
      label: text,
      'data-testid': 'priceEditor.percentageTiers.toggleFeeThresholds',
      onClick: () => {
        args.onChange(!args.includePercentageLimits)
      }
    }
  ]

  if (args.percentageTiers && args.currency) {
    menuItems.push({
      label: 'Copy pricing table',
      onClick: async () => {
        await copyPricingTableToClipboard({
          percentageTiers: args.percentageTiers!,
          currency: args.currency!,
          includeLimits: args.includePercentageLimits
        })
      }
    })
  }

  return menuItems
}
